/**
 * Fallback screen shown when no restaurant ID is provided in production mode
 * Displays the Tabbly logo with a clean branded interface
 */
export class NoRestaurantScreen {
  constructor() {
    this.container = null;
  }

  /**
   * Create and display the no restaurant screen
   */
  show() {
    this.container = document.createElement('div');
    this.container.className = 'no-restaurant-screen';
    
    this.container.innerHTML = `
      <div class="no-restaurant-content">
        <div class="tabbly-logo">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Tabbly logo icon (fork and knife) -->
            <rect x="10" y="10" width="100" height="100" rx="20" fill="none" stroke="#C7D941" stroke-width="8"/>
            <!-- Fork -->
            <path d="M35 30 L35 70 M30 30 L30 45 M40 30 L40 45" stroke="#C7D941" stroke-width="4" stroke-linecap="round"/>
            <!-- Knife -->
            <path d="M75 30 L75 70 M75 30 L85 40 L85 45 L75 35" stroke="#C7D941" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h1 class="tabbly-title">Tabbly</h1>
        <p class="tabbly-subtitle">Restaurant Menu Platform</p>
      </div>
    `;

    // Add styles
    this.addStyles();
    
    // Replace app content
    const appContainer = document.getElementById('app');
    if (appContainer) {
      appContainer.innerHTML = '';
      appContainer.appendChild(this.container);
    }
  }

  /**
   * Hide the no restaurant screen
   */
  hide() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
      this.container = null;
    }
  }

  /**
   * Add CSS styles for the no restaurant screen
   */
  addStyles() {
    const styleId = 'no-restaurant-styles';
    
    // Don't add styles if they already exist
    if (document.getElementById(styleId)) {
      return;
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .no-restaurant-screen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: linear-gradient(135deg, #1a3b47 0%, #2d5a6b 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }

      .no-restaurant-content {
        text-align: center;
        max-width: 400px;
        padding: 2rem;
      }

      .tabbly-logo {
        margin-bottom: 2rem;
        display: flex;
        justify-content: center;
      }

      .tabbly-logo svg {
        width: 120px;
        height: 120px;
        filter: drop-shadow(0 4px 12px rgba(199, 217, 65, 0.3));
      }

      .tabbly-title {
        font-size: 4rem;
        font-weight: 700;
        color: #C7D941;
        margin: 1rem 0 0.5rem 0;
        letter-spacing: -0.02em;
        text-shadow: 0 2px 8px rgba(199, 217, 65, 0.4);
      }

      .tabbly-subtitle {
        font-size: 1.25rem;
        color: rgba(255, 255, 255, 0.8);
        margin: 0;
        font-weight: 400;
        letter-spacing: 0.5px;
      }

      /* Tablet optimizations */
      @media (min-width: 768px) {
        .tabbly-title {
          font-size: 5rem;
        }
        
        .tabbly-subtitle {
          font-size: 1.5rem;
        }
        
        .tabbly-logo svg {
          width: 150px;
          height: 150px;
        }
      }

      /* Large tablet/kiosk optimizations */
      @media (min-width: 1024px) {
        .tabbly-title {
          font-size: 6rem;
        }
        
        .tabbly-subtitle {
          font-size: 1.75rem;
        }
        
        .tabbly-logo svg {
          width: 180px;
          height: 180px;
        }
      }

      /* Animation for smooth appearance */
      .no-restaurant-screen {
        animation: fadeIn 0.6s ease-out;
      }

      .tabbly-logo {
        animation: logoFloat 3s ease-in-out infinite;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes logoFloat {
        0%, 100% {
          transform: translateY(0px);
        }
        50% {
          transform: translateY(-10px);
        }
      }
    `;

    document.head.appendChild(style);
  }
}